export default "__VITE_ASSET__BEZh2gBB__"